export default __webpack_public_path__ + "static/media/julio-oliveira.221a16eb.jpg";